document.addEventListener("DOMContentLoaded", function () {
  const mh_cnm_split_banner_crsl = new Swiper(".mh-cnm-split-banner-crsl", {
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 700,
    allowTouchMove: true,
    navigation: {
      nextEl: ".mh-cnm-split-banner-crsl .mh-cnm-split-banner-crsl-navbtn-next",
      prevEl: ".mh-cnm-split-banner-crsl .mh-cnm-split-banner-crsl-navbtn-prev",
    },
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const mh_cnm_prd_shwcase_crsl = new Swiper(".mh-cnm-clctn-shwcase__crsl", {
    slidesPerView: 4.3,
    speed: 700,
    spaceBetween: 20,
    allowTouchMove: true,
    scrollbar: {
      el: ".mh-cnm-clctn-shwcase-crsl__scrollbar",
      draggable: true, // user can drag the bar
      hide: false, // keep it visible (set true to auto-hide)
      snapOnRelease: true,
    },
    navigation: {
      nextEl: ".mh-cnm-clctn-shwcase-nav-block .swiper-button-next",
      prevEl: ".mh-cnm-clctn-shwcase-nav-block .swiper-button-prev",
    },
    mousewheel: { forceToAxis: true },
    breakpoints: {
      0:   { slidesPerView: 2, spaceBetween: 12 },
      480: { slidesPerView: 2, spaceBetween: 12 },
      768: { slidesPerView: 3, spaceBetween: 16 },
      992: { slidesPerView: 4, spaceBetween: 16 },
      1920: { slidesPerView: 5, spaceBetween: 16 }
    }
  });
});

(function () {
  // we don't return early if Swiper is missing,
  // because grid layout doesn't need Swiper
  var sections = document.querySelectorAll('.mh-cnm-prd-shwcase-wrpr');
  if (!sections.length) return;

  function destroyActive(sectionEl) {
    var active = sectionEl.__activeInst;
    if (active && active.destroy) {
      try { active.destroy(true, true); } catch (e) {}
    }
    sectionEl.__activeInst = null;
    sectionEl.__activePanel = null;
  }

  function buildConfig(panelEl) {
    var prevSel = panelEl.getAttribute('data-prev');
    var nextSel = panelEl.getAttribute('data-next');
    var scrollbarSel = panelEl.getAttribute('data-scrollbar');
    return {
      slidesPerView: 4.3,
      spaceBetween: 20,
      allowTouchMove: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      navigation: {
        nextEl: prevSel ? document.querySelector(nextSel) : null,
        prevEl: prevSel ? document.querySelector(prevSel) : null
      },
      scrollbar: {
        el: scrollbarSel ? document.querySelector(scrollbarSel) : null,
        draggable: true,
        hide: false,
        snapOnRelease: true
      },
      mousewheel: { forceToAxis: true },
      breakpoints: {
        0:   { slidesPerView: 2,   spaceBetween: 12 },
        480: { slidesPerView: 2, spaceBetween: 12 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        992: { slidesPerView: 4, spaceBetween: 16 },
        1920:{ slidesPerView: 5, spaceBetween: 16 },
        2160:{ slidesPerView: 6, spaceBetween: 16 }
      }
    };
  }

  function initSwiper(sectionEl, panelEl) {
    var layout = sectionEl.getAttribute('data-layout') || 'carousel';
    if (layout !== 'carousel') {
      // grid mode: don't init Swiper
      destroyActive(sectionEl);
      return;
    }
    if (typeof Swiper === 'undefined') {
      console.warn('[Product Showcase Tabs] Swiper missing');
      return;
    }
    if (!panelEl) return;

    if (sectionEl.__activePanel === panelEl && sectionEl.__activeInst) {
      sectionEl.__activeInst.update && sectionEl.__activeInst.update();
      return;
    }
    destroyActive(sectionEl);
    var cfg = buildConfig(panelEl);
    var instance = new Swiper(panelEl, cfg);
    sectionEl.__activeInst = instance;
    sectionEl.__activePanel = panelEl;
    if (instance.navigation && instance.navigation.update) instance.navigation.update();
    if (instance.scrollbar && instance.scrollbar.updateSize) instance.scrollbar.updateSize();
  }

  function showPanel(sectionEl, targetPanel) {
    var panels = sectionEl.querySelectorAll('.mh-cnm-prd-shwcase-crsl, .mh-cnm-prd-shwcase-grid');
    panels.forEach(function (el) {
      if (el === targetPanel) {
        el.hidden = false;
        el.removeAttribute('hidden');
        el.style.display = '';
      } else {
        if (!el.hasAttribute('hidden')) el.setAttribute('hidden', '');
        el.hidden = true;
        el.style.display = 'none';
      }
    });
    initSwiper(sectionEl, targetPanel);
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.mhTabsInited === '1') return;
    sectionEl.dataset.mhTabsInited = '1';

    var layout = sectionEl.getAttribute('data-layout') || 'carousel';
    var tabButtons = sectionEl.querySelectorAll('.mh-cnm-prd-showcase__tab');
    var selectEl  = sectionEl.querySelector('.mh-cnm-prd-showcase__select-el');

    var firstVisible = sectionEl.querySelector('.mh-cnm-prd-shwcase-crsl:not([hidden]), .mh-cnm-prd-shwcase-grid:not([hidden])');
    var allPanels    = sectionEl.querySelectorAll('.mh-cnm-prd-shwcase-crsl, .mh-cnm-prd-shwcase-grid');
    var initialPanel = firstVisible || allPanels[0];

    if (initialPanel) {
      initialPanel.hidden = false;
      initialPanel.removeAttribute('hidden');
      showPanel(sectionEl, initialPanel);
    }

    // Tabs → panel
    if (tabButtons.length) {
      tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          tabButtons.forEach(function (b) {
            b.classList.remove('mh-cnm-prd-showcase__tab--active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('mh-cnm-prd-showcase__tab--active');
          btn.setAttribute('aria-selected', 'true');

          var targetId = btn.getAttribute('data-tab-target');
          if (!targetId) return;
          var panel = sectionEl.querySelector('#' + targetId);
          if (!panel) return;

          if (selectEl) selectEl.value = targetId;
          showPanel(sectionEl, panel);
        });
      });
    }

    // Select → panel
    if (selectEl) {
      if (sectionEl.__activePanel && sectionEl.__activePanel.id) {
        selectEl.value = sectionEl.__activePanel.id;
      }
      selectEl.addEventListener('change', function () {
        var targetId = this.value;
        var panel = sectionEl.querySelector('#' + targetId);
        if (!panel) return;

        tabButtons.forEach(function (b) {
          var tid = b.getAttribute('data-tab-target');
          var isActive = (tid === targetId);
          b.classList.toggle('mh-cnm-prd-showcase__tab--active', isActive);
          b.setAttribute('aria-selected', String(isActive));
        });

        showPanel(sectionEl, panel);
      });
    }

    // Show more / Show less toggle (grid layout only – but safe to run even if layout = carousel)
    var toggleButtons = sectionEl.querySelectorAll('.mh-cnm-prd-shwcase__load-more');
    if (toggleButtons.length) {
      toggleButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.getAttribute('data-load-more-for');
          if (!targetId) return;

          var panel = sectionEl.querySelector('#' + targetId);
          if (!panel) return;

          var gridInner = panel.querySelector('.mh-cnm-prd-shwcase-grid__inner');
          if (!gridInner) return;

          var initialCount = parseInt(gridInner.getAttribute('data-initial-count'), 10) || 0;
          var items = gridInner.querySelectorAll('.mh-cnm-prd-shwcase-grid__item');
          var isExpanded = btn.getAttribute('data-expanded') === '1';

          if (!isExpanded) {
            // Expand: show all products
            items.forEach(function (item) {
              item.removeAttribute('data-hidden');
              item.style.display = '';
            });
            btn.textContent = 'Show less products';
            btn.setAttribute('data-expanded', '1');
          } else {
            // Collapse: hide back to initial count
            var visibleCount = 0;
            items.forEach(function (item) {
              visibleCount++;
              if (visibleCount > initialCount && initialCount > 0) {
                item.setAttribute('data-hidden', '1');
                item.style.display = 'none';
              } else {
                item.removeAttribute('data-hidden');
                item.style.display = '';
              }
            });
            btn.textContent = 'Show more products';
            btn.setAttribute('data-expanded', '0');

            // optional: scroll grid back into view for better UX
            panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
  }

  sections.forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('shopify-section-' + (e.detail && e.detail.sectionId));
    if (!root) return;
    root.querySelectorAll('.mh-cnm-prd-shwcase-wrpr').forEach(function (sec) {
      if (sec.__activeInst && sec.__activeInst.destroy) {
        try { sec.__activeInst.destroy(true, true); } catch (err) {}
      }
      sec.__activeInst = null;
      sec.__activePanel = null;
      sec.dataset.mhTabsInited = '';
      initSection(sec);
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.cnm-coordinating-swiper');

  sliders.forEach(function (sliderEl) {
    var prevSelector = sliderEl.getAttribute('data-prev');
    var nextSelector = sliderEl.getAttribute('data-next');

    var prevEl = document.querySelector(prevSelector);
    var nextEl = document.querySelector(nextSelector);

    if (!prevEl || !nextEl) return;

    new Swiper('#' + sliderEl.id, {
      slidesPerView: 2,
      spaceBetween: 16,
      autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true
      },
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 }
      }
    });
  });
});

/* Ajax Add to Cart Script For Product Cards */
(() => {
  // Prevent double-binding
  if (window.__mhBasicAtcDrawerBound) return;
  window.__mhBasicAtcDrawerBound = true;

  const SELECTOR_FORM = 'form[action="/cart/add"]';
  const SELECTOR_BTN  = 'button[type="submit"]';

  function getAddUrl() {
    return (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
  }

  function getDrawer() {
    return document.querySelector('cart-drawer.mh-cmm__cart-drawer') || document.querySelector('cart-drawer');
  }

  function setBtnLoading(btn, loading) {
    if (!btn) return;

    if (loading) {
      if (!btn.dataset.mhOriginalHtml) btn.dataset.mhOriginalHtml = btn.innerHTML;

      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('mh-atc-loading');

      // keep icon + span structure and add loader span
      const icon = btn.querySelector('i')?.outerHTML || '<i class="icon-cart"></i>';
      btn.innerHTML = `${icon}<span>Adding…</span><span class="mh-atc-loader" aria-hidden="true"></span>`;
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('mh-atc-loading');

      if (btn.dataset.mhOriginalHtml) btn.innerHTML = btn.dataset.mhOriginalHtml;
    }
  }

  function setBtnAdded(btn) {
    if (!btn) return;
    const icon = btn.querySelector('i')?.outerHTML || '<i class="icon-cart"></i>';
    btn.innerHTML = `${icon}<span>Item Added</span>`;
  }

  function replaceCartSections(sections) {
    if (!sections) return;

    // cart icon bubble
    if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const fresh = doc.querySelector('#cart-icon-bubble');
      const current = document.querySelector('#cart-icon-bubble');
      if (fresh && current) current.replaceWith(fresh);
    }

    // cart drawer
    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const freshDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      if (freshDrawer && currentDrawer) {
        // replace inner to keep custom element instance
        currentDrawer.innerHTML = freshDrawer.innerHTML;
      }
    }
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  async function onSubmit(e) {
    const form = e.target;
    if (!form || !form.matches(SELECTOR_FORM)) return;

    // Only handle your product-card forms (the ones Bold uses)
    if (!form.querySelector('.bold-bundles-product')) return;
    if (!form.querySelector('select[name="id"], input[name="id"]')) return;

    e.preventDefault();

    const btn = form.querySelector(SELECTOR_BTN);
    setBtnLoading(btn, true);

    try {
      const fd = new FormData(form);

      // Append sections at runtime (no HTML inputs needed)
      if (!fd.get('sections')) fd.append('sections', 'cart-drawer,cart-icon-bubble');
      if (!fd.get('sections_url')) fd.append('sections_url', window.location.pathname);

      const res = await fetch(getAddUrl(), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      });

      const data = await res.json();

      if (!res.ok || data.status === 422) {
        console.error('ATC error:', data);
        setBtnLoading(btn, false);
        return;
      }

      const drawer = getDrawer();

      // Dawn best path (if available)
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
        openDrawer();
      } else {
        // Fallback: replace sections from response
        replaceCartSections(data.sections);
        openDrawer();
      }

      setBtnAdded(btn);

      // Restore original button after a moment (optional)
      setTimeout(() => setBtnLoading(btn, false), 1200);

    } catch (err) {
      console.error('ATC AJAX failed:', err);
      setBtnLoading(btn, false);
      form.submit(); // last resort (normal submit)
    }
  }

  // Delegated submit listener (keeps working after your AJAX section replacement)
  document.addEventListener('submit', onSubmit, true);
})();



/* Seconday Collection Banner JS */
function initCnmSecondaryCollectionBanners(scope = document) {
  const swipers = scope.querySelectorAll('[data-mh-cnm-secondary-swiper]');
  if (!swipers.length || typeof Swiper === 'undefined') return;

  swipers.forEach((swiperEl) => {
    if (swiperEl.__mhSwiperInitialized) return;

    const root = swiperEl.closest('.shopify-section') || document;
    const paginationEl = root.querySelector('.mh-cnm-secondary-clctn-swiper-pagination');
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const shouldLoop = slideCount > 3;

    swiperEl.__mhSwiperInstance = new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 16,
      loop: shouldLoop,
      speed: 600,
      watchOverflow: true,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 12
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 14
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 16
        }
      }
    });

    swiperEl.__mhSwiperInitialized = true;
  });
}

function destroyCnmSecondaryCollectionBanner(sectionEl) {
  if (!sectionEl) return;

  const swipers = sectionEl.querySelectorAll('[data-mh-cnm-secondary-swiper]');
  swipers.forEach((swiperEl) => {
    if (
      swiperEl.__mhSwiperInstance &&
      typeof swiperEl.__mhSwiperInstance.destroy === 'function'
    ) {
      swiperEl.__mhSwiperInstance.destroy(true, true);
    }

    swiperEl.__mhSwiperInstance = null;
    swiperEl.__mhSwiperInitialized = false;
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCnmSecondaryCollectionBanners(document);
});

document.addEventListener('shopify:section:load', function (e) {
  if (!e.target) return;
  initCnmSecondaryCollectionBanners(e.target);
});

document.addEventListener('shopify:section:unload', function (e) {
  if (!e.target) return;
  destroyCnmSecondaryCollectionBanner(e.target);
});



document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.mh-cnm-clctn-prd-shwcase-wrpr');
  if (!section) return;

  const sectionWrapper = section.closest('.shopify-section');
  if (!sectionWrapper || !sectionWrapper.id) return;

  const sectionId = sectionWrapper.id.replace('shopify-section-', '');

  const currentUrl = new URL(window.location.href);
  const fetchUrl = new URL(window.location.origin + window.location.pathname);

  fetchUrl.searchParams.set('sort_by', 'best-selling');
  fetchUrl.searchParams.set('section_id', sectionId);

  fetch(fetchUrl.toString())
    .then(function (response) {
      if (!response.ok) throw new Error('Section render failed');
      return response.text();
    })
    .then(function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newSection = doc.querySelector('.mh-cnm-clctn-prd-shwcase-wrpr');
      if (!newSection) return;

      section.innerHTML = newSection.innerHTML;

      if (typeof window.initCollectionProductShowcaseSwiper === 'function') {
        window.initCollectionProductShowcaseSwiper(section);
      }
    })
    .catch(function (error) {
      console.warn('Best selling section render error:', error);
    });
});

window.initCollectionProductShowcaseSwiper = function (scope) {
  const section = scope || document.querySelector('.mh-cnm-clctn-prd-shwcase-wrpr');
  if (!section) return;

  const swiperEl = section.querySelector('.mh-cnm-clctn-prd-shwcase-crsl');
  if (!swiperEl) return;
  if (swiperEl.classList.contains('swiper-initialized')) return;

  const prevEl = swiperEl.dataset.prev ? section.querySelector(swiperEl.dataset.prev) : null;
  const nextEl = swiperEl.dataset.next ? section.querySelector(swiperEl.dataset.next) : null;
  const scrollbarEl = swiperEl.dataset.scrollbar ? section.querySelector(swiperEl.dataset.scrollbar) : null;

  new Swiper(swiperEl, {
    slidesPerView: 2,
    spaceBetween: 12,
    watchOverflow: true,

    navigation: prevEl && nextEl ? {
      prevEl: prevEl,
      nextEl: nextEl
    } : false,

    scrollbar: scrollbarEl ? {
      el: scrollbarEl,
      draggable: true
    } : false,

    breakpoints: {
      0: { slidesPerView: 2, spaceBetween: 12 },
      480: { slidesPerView: 2, spaceBetween: 12 },
      768: { slidesPerView: 3, spaceBetween: 16 },
      992: { slidesPerView: 4, spaceBetween: 16 },
      1920: { slidesPerView: 5, spaceBetween: 16 },
      2160: { slidesPerView: 6, spaceBetween: 16 }
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.mh-cnm-clctn-prd-shwcase-wrpr');
  if (!section) return;

  window.initCollectionProductShowcaseSwiper(section);
});